import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { Avatar } from "@mui/material";
import EditProfile from "../../assets/assets/images/profile/profile_1.png";
import Booking from "../../assets/assets/images/profile/profile_2.png";
import Support from "../../assets/assets/images/profile/profile_6.png";
import Terms from "../../assets/assets/images/profile/profile_5.png";
import Logoutimg from "../../assets/assets/images/profile/profile_8.png";
import DeleteImg from "../../assets/bin.png";
import Notification from "../../assets/assets/images/profile/profile_3.png";
import Verified from "../../assets/verified.png";
import caricon from "../../assets/electric-car.png";
import shoppingCart from "../../assets/shopping-cart.png";
import Languages from "../../assets/language.png";
import Favourite from "../../assets/heart.png";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import Modal from "../fields/Modal";
import {
  Logout,
  getUserDetail,
  deletemyaccount,
} from "../../redux/Slice/authSlice";
import { cleanData, cleanLoaction } from "../../redux/Slice/formSlice";
import { cleanBookingData } from "../../redux/Slice/bookingSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getAllCars } from "../../redux/Slice/carSlice";

export default function Profile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const loginDetail = useSelector((state) => state?.auth?.loginDetail)
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const loginDetail = useSelector((state) => state?.auth?.loginId);
  const userInfo = useSelector((state) => state?.auth?.userDetail);
  const deleteStatus = useSelector((state) => state?.auth?.deleteStatus);

  const [state, setState] = useState({
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    if (open) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
    setState({ ...state, [anchor]: open });
  };

  function logout() {
    dispatch(Logout());
    dispatch(getAllCars());
    dispatch(cleanData());
    dispatch(cleanLoaction());
    dispatch(cleanBookingData());
    navigate("/");
  }

  const deleteHandler = async (id) => {
    let response = await dispatch(deletemyaccount({ userId: id }));
    if (response?.payload?.success === true) {
      toast(response?.payload?.message);
      setTimeout(() => {
        dispatch(Logout());
        dispatch(getAllCars());
        dispatch(cleanData());
        dispatch(cleanLoaction());
        dispatch(cleanBookingData());
        navigate("/");
      }, 2000);
    } else {
      toast(response?.payload?.message);
    }
    // old code it run 2nd time due to redux value. it store on first time then show in 2nd time
    // if (deleteStatus?.success === true) {
    //   toast(deleteStatus?.message);
    //   setTimeout(() => {
    //     dispatch(Logout());
    //     dispatch(cleanData());
    //     dispatch(cleanLoaction());
    //     dispatch(cleanBookingData());
    //     navigate("/");
    //   }, 2000);
    // } else {
    //   toast(deleteStatus?.message);
    // }
  };
  useEffect(() => {
    if (userInfo?.data?.deleteAccount) {
      logout();
    }
  }, [userInfo]);

  useEffect(() => {
    if (loginDetail) {
      dispatch(getUserDetail(loginDetail));
    }

    // dispatch(getUserDetail(loginDetail?.data?._id))
  }, [loginDetail]);

  const profileList = [
    {
      id: 1,
      title: "My Account",
      icon: EditProfile,
      path: "/edit-profile",
    },
    {
      id: 2,
      title: "My booking",
      path: "/mybooking",
      icon: Booking,
    },
    {
      id: 3,
      title: "My Vehicle",
      path: "/myvehicle",
      icon: caricon,
    },
    {
      id: 4,
      title: "Orders",
      path: "/orders",
      icon: shoppingCart,
    },
    {
      id: 5,
      title: "Favourite",
      path: "/favourites",
      icon: Favourite,
    },
    {
        id: 8,
        title: "Notification",
        path: '/notification',
        icon: Notification
    },
   
    // {
    //     id: 5,
    //     title: "Languages",
    //     icon: Languages
    // },
    // {
    //     id: 7,
    //     title: "Languages",
    //     path: '/languages',
    //     icon: Languages
    // },
    {
      id: 6,
      title: "Terms and Condition",
      path: "/termsandcondition",
      icon: Terms,
    },
    {
      id: 7,
      title: "Customer Support",
      path: "/contactus",
      icon: Support,
    },
    // {
    //   id: 8,
    //   title: "Languages",
    //   path: "/languages",
    //   icon: Languages,
    // },
    // {
    //     id: 8,
    //     title: "Log out",
    //     path: '/',
    //     icon: Logout
    // },
  ];
  return (
    <>
      <div>
        <Button>
          {/* {(userInfo?.data?.socialId) ? (
                        <Avatar onClick={toggleDrawer("right", true)} data-tooltip-id="profile" alt="user profile" src={`${userInfo?.data?.image}`} />
                    ) : (
                        <Avatar onClick={toggleDrawer("right", true)} data-tooltip-id="profile" alt="user profile" src={`${baseURL}${userInfo?.data?.image}`} />
                    )} */}
          <Avatar
            onClick={toggleDrawer("right", true)}
            data-tooltip-id="profile"
            alt="user profile"
            src={
              userInfo?.data?.image
                ? userInfo.data.image.includes("http")
                  ? userInfo.data.image
                  : `${baseURL}${userInfo.data.image}`
                : null
            }
          />
        </Button>
        <ReactTooltip id="profile" place="bottom" content="Profile" />
        <Drawer
          anchor={"right"}
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
          disableScrollLock={true}
        >
          <Box
            role="presentation"
            onClick={toggleDrawer("right", false)}
            onKeyDown={toggleDrawer("right", false)}
          >
            <List>
              <div className="d-flex align-items-center gap-2 p-4">
                {/* {(userInfo?.data?.socialId) ? (
                                    <Avatar alt="user profile" src={`${userInfo?.data?.image}`} />
                                ) : (
                                    <Avatar alt="user profile" src={`${baseURL}${userInfo?.data?.image}`} />
                                )} */}
                <Avatar
                  alt="user profile"
                  src={
                    userInfo?.data?.image
                      ? userInfo.data.image.includes("http")
                        ? userInfo.data.image
                        : `${baseURL}${userInfo?.data?.image}`
                      : null
                  }
                />
                <div>
                  <h6 className="mb-0">
                    {userInfo?.data?.name}
                    <img src={Verified} width="20px" />
                  </h6>
                  <p className="fs14">{userInfo?.data?.emailId}</p>
                </div>
              </div>
              {profileList.map((item, index) => (
                <div
                  key={item.id}
                  // className={
                  //   item.title === "Notification" ? "notif-display" : null
                  // }
                >
                  <Link to={item.path}>
                    <ListItem>
                      <ListItemButton>
                        <img className="profile-icon" src={item.icon} />
                        <ListItemText primary={item.title} />
                      </ListItemButton>
                    </ListItem>
                  </Link>
                  <hr className="my-0" />
                </div>
              ))}
              <ListItem>
                <ListItemButton
                  data-bs-toggle="modal"
                  data-bs-target="#logoutModal"
                >
                  <img className="profile-icon" src={Logoutimg} />
                  <ListItemText primary="Logout" />
                </ListItemButton>
              </ListItem>
              <hr className="my-0" />
              <ListItem>
                <ListItemButton
                  data-bs-toggle="modal"
                  data-bs-target="#deleteModal"
                >
                  <img className="profile-icon" src={DeleteImg} />
                  <ListItemText primary="Delete" />
                </ListItemButton>
              </ListItem>
              <hr className="my-0" />
            </List>
          </Box>
        </Drawer>
      </div>
      <Modal
        id="logoutModal"
        modalTitle="Logout"
        modalBody="Are you sure you want to Log out?"
        handleAccept={logout}
      />
      <Modal
        id="deleteModal"
        modalTitle="Delete Account"
        modalBody="Are you sure you want to Delete Account?"
        handleAccept={() => deleteHandler(userInfo?.data?._id)}
      />
    </>
  );
}
